import Button from "components/Button/Button";
import { lang } from "constant/lang";
import React from "react";
import { AiOutlineCalendar, AiOutlineEnvironment } from "react-icons/ai";
import { Link } from "react-router-dom";

const EventMiniCard = ({ eventName, className }) => {
  const event = lang.events?.[eventName];

  return (
    <div
      className={`flex flex-col p-6 bg-white shadow-wce-hard rounded-2xl gap-2 w-full max-w-[400px] h-30 ${className}
        border-2 border-white items-center`}
      style={{
        background:
          "linear-gradient(105.84deg, #FAC8D0 28.18%, #F5F5F5 123.05%)",
      }}
    >
      <div className="font-medium text-wce-navy-light md:text-2xl mb-2">
        {event?.title}
      </div>
      <div className="flex gap-2 text-sm md:text-base">
        <AiOutlineCalendar size={20} className="text-wce-neutral-8" />
        <div className="text-wce-neutral-9">{event?.date}</div>
      </div>
      <div className="flex gap-2 mb-2 text-sm md:text-base">
        <AiOutlineEnvironment size={20} className="text-wce-neutral-8" />
        <div className="text-wce-neutral-9">{event?.location}</div>
      </div>
      <div>
        {event?.show ? (
          <Link to={event?.link}>
            <Button
              color="danger"
              size="large"
              rounded
              className={"w-32 md:w-40"}
            >
              Learn More
            </Button>
          </Link>
        ) : (
          <Button
            color="danger"
            size="large"
            rounded
            className={"w-[160px]"}
            disabled={true}
          >
            Coming Soon!
          </Button>
        )}
      </div>
    </div>
  );
};

export default EventMiniCard;
